module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-13-b686b6de2cc6c169613cb874cdd9b4dd.svg";